module.exports = __webpack_public_path__ + "img/pro4.1ad65877.jpg";